export default {
  props: {
    // Check if there are any unread numbers
    checkExistUnreadPhoneNumbers: Function,
    gotoNextPage: Function,
  },
};
